/**
 * Room-scoped socket events are emitted with inconsistent payloads across the
 * backend (a bare id, `{ roomId }`, or a full room document), so every consumer
 * has to normalise before comparing ids.
 */
export function resolveSocketRoomId(payload) {
  if (payload == null || payload === "") return null;
  if (typeof payload === "string" || typeof payload === "number") {
    return String(payload);
  }
  const id =
    payload.roomId ?? payload.room_id ?? payload._id ?? payload.id ?? null;
  return id != null && id !== "" ? String(id) : null;
}

/**
 * Chat list rows expose the room id as `id`, while room-scoped socket consumers
 * (widget included) read `_id`/`roomId`. Send every spelling so a room event is
 * never dropped over a key mismatch.
 */
export function buildRoomSocketPayload(room) {
  const roomId = resolveSocketRoomId(room);
  if (!roomId) return null;
  if (typeof room === "string" || typeof room === "number") {
    return { _id: roomId, id: roomId, roomId };
  }
  return {
    ...room,
    _id: roomId,
    id: roomId,
    roomId,
    roomName: room.roomName || room.title || "",
  };
}

export default resolveSocketRoomId;
